import{PREFIX as t,OBJECT as e,UNDEFINED as r}from"@analytics/type-utils";var n="global",o=t+n+t,l=typeof self===e&&self.self===self&&self||typeof global===e&&global[n]===global&&global||void 0;function f(t){return l[o][t]}function a(t,e){return l[o][t]=e}function i(t){delete l[o][t]}function u(t,e,r){var n;try{if(s(t)){var o=window[t];n=o[e].bind(o)}}catch(t){}return n||r}l[o]||(l[o]={});var c={};function s(t){if(typeof c[t]!==r)return c[t];try{var e=window[t];e.setItem(r,r),e.removeItem(r)}catch(e){return c[t]=!1}return c[t]=!0}export{n as GLOBAL,o as KEY,f as get,l as globalContext,s as hasSupport,i as remove,a as set,u as wrap};
//# sourceMappingURL=analytics-util-global-storage.module.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@analytics/global-storage-utils/dist/analytics-util-global-storage.module.js
// module id = +nUJ
// module chunks = 0